export default __webpack_public_path__ + "static/media/expl-nn_04_DE.b93604d5.png";